import { Box, CardContent, CardMedia, Typography } from "@material-ui/core";
import { Card } from "../../_metronic/_partials/controls";

export const TarjetaModelo = ({ modelo, hideSpecs = false }) => {
  if (!modelo) return null;
  const obtenerColor = (nombreColor) => {
    const colores = {
      Champán: { backgroundColor: "#F7E7CE" },
      Azul: { backgroundColor: "#0000FF" },
      Verde: { backgroundColor: "#008000" },
      Negro: { backgroundColor: "#000" },
      Oro: {
        backgroundImage:
          "linear-gradient(45deg, #faba0a, #bf8f0b, #ffc800, #FFF5CC)",
      },
      Gris: { backgroundColor: "#808080" },
      Blanco: { backgroundColor: "#F0F0F0" },
      Plata: {
        backgroundImage:
          "linear-gradient(45deg, #C0C0C0, #D3D3D3, #E0E0E0, #F8F8F8)",
      },
      Acero: {
        backgroundImage:
          "linear-gradient(45deg,rgb(141, 135, 135),rgb(227, 214, 214),rgb(211, 190, 190),rgb(148, 146, 146))",
      },
      Titanio: {
        backgroundImage:
          "linear-gradient(45deg,rgb(141, 135, 135),rgb(227, 214, 214),rgb(211, 190, 190),rgb(148, 146, 146))",
      },
      Titanio: {
        backgroundImage:
          "linear-gradient(45deg,rgb(141, 135, 135),rgb(227, 214, 214),rgb(211, 190, 190),rgb(148, 146, 146))",
      },
      Cerámica: {
        backgroundImage:
          "linear-gradient(45deg,rgb(174, 165, 165),rgb(227, 214, 214),rgb(235, 216, 216),rgb(190, 181, 181))",
      },
      "Acero y oro": {
        backgroundImage:
          "linear-gradient(45deg,rgb(179, 179, 179),rgb(156, 156, 156), #ffc800,rgb(192, 192, 192))",
      },
      "Oro amarillo": {
        backgroundImage:
          "linear-gradient(45deg,rgb(228, 217, 61),rgb(243, 228, 8),rgb(210, 169, 20),rgb(142, 133, 20))",
      },
      "Oro rosa": {
        backgroundImage:
          "linear-gradient(45deg,rgb(186, 121, 61),rgb(239, 190, 134),rgb(239, 197, 159),rgb(166, 91, 5))",
      },
      Platino: {
        backgroundImage:
          "linear-gradient(45deg,rgb(79, 77, 77),rgb(228, 216, 216),rgb(179, 164, 164),rgb(55, 54, 54))",
      },
      "Oro blanco": {
        backgroundImage:
          "linear-gradient(45deg,rgb(184, 181, 181),rgb(244, 239, 239),rgb(217, 215, 215),rgb(137, 134, 134))",
      },
    };
    return {
      width: 12,
      height: 12,
      borderRadius: "50%",
      display: "inline-block",
      marginRight: 1,
      ...colores[nombreColor],
    };
  };
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "1px solid #ddd",
        padding: 2,
        cursor: "pointer",
      }}
    >
      <div className="row justify-content-left">
        <div className="col-4 col-md-4 text-left my-2">
          <CardMedia
            component="img"
            height="200"
            image={modelo.urlImage}
            alt={modelo.nombre}
            sx={{ objectFit: "cover" }}
          />
        </div>
        <div className="col-8 col-md-8 text-left p-0">
          <CardContent className="p-0 m-2">
            <div className="flex-column d-flex align-items-left p-0">
              <div className="col-md-12 p-0">
                <Typography variant="h5" component="div">
                  {modelo.nombre}
                </Typography>
              </div>
              <div className="col-md-12 p-0 mt-2 mb-6">
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "1.2rem" }}
                >
                  {modelo.sku}
                </Typography>
              </div>
            </div>
            {!hideSpecs && (
              <>
                <div className="row d-flex justify-content-left pt-2">
                  <div className="col-md-4">
                    <Typography
                      variant="h6"
                      color="text.secondary"
                      component="div"
                      sx={{ fontSize: "1.2rem" }}
                    >
                      <strong>Material de la caja</strong>
                    </Typography>
                  </div>
                  <div className="col-md-4">
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ fontSize: "1.2rem" }}
                    >
                      <strong>Esfera</strong>
                    </Typography>
                  </div>
                  <div className="col-md-4">
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ fontSize: "1.2rem" }}
                    >
                      <strong>Diámetro</strong>
                    </Typography>
                  </div>
                </div>
                <div className="row d-flex justify-content-left pt-2">
                  <div className="col-md-4">
                    <Typography variant="body2" sx={{ fontSize: "1rem" }}>
                      {modelo.materialCaja && (
                        <Box sx={obtenerColor(modelo.materialCaja)} />
                      )}
                      {modelo.materialCaja}
                    </Typography>
                  </div>
                  <div className="col-md-4">
                    <Typography variant="body2" sx={{ fontSize: "1rem" }}>
                      {modelo.colorEsfera && (
                        <Box sx={obtenerColor(modelo.colorEsfera)} />
                      )}
                      {modelo.colorEsfera}
                    </Typography>
                  </div>
                  <div className="col-md-4">
                    <Typography variant="body2" sx={{ fontSize: "1rem" }}>
                      {modelo.diametro}
                    </Typography>
                  </div>
                </div>
              </>
            )}
          </CardContent>
        </div>
      </div>
    </Card>
  );
};
